const $support = $('.product-detail .support');

if ($support.length) {
  const self = {};

  /** Initialise the module. */
  self.initialise = function initialise() {
    const $view = $('.js-support-info');
    const $contents = $('.support-content', $support);

    $view.click(() => {
      $contents.slideToggle();

      const $ttiIframe = $support.find('iframe');
      if ($ttiIframe.attr('src') === undefined && $ttiIframe.attr('data-src') !== undefined) {
        $ttiIframe.attr('src', $ttiIframe.attr('data-src'));
      }
    });
  };

  self.initialise();
}
